
const globalConfig = document.body.dataset || {};
interface anwendunglisteConfig {
  anwendungslisteTextStandard?: string,
  anwendungslisteTextEdit?: string
}

const anwendungsliste = document.getElementById('anwendungsliste');
let anwendungslisteConfig: anwendunglisteConfig = {
  anwendungslisteTextStandard: '',
  anwendungslisteTextEdit:''
};

if (anwendungsliste) {
  anwendungslisteConfig = anwendungsliste.dataset;
}

interface anwendunglisteFavoritenConfig {
  anwendungslisteLink?: string
}

const anwendungslisteFavoriten = document.getElementById('anwendungslistefavoriten');
let anwendungslisteFavoritenConfig: anwendunglisteFavoritenConfig = {
  anwendungslisteLink: '/'
};

if (anwendungslisteFavoriten) {
  anwendungslisteFavoritenConfig = anwendungslisteFavoriten.dataset;
}


interface linklisteConfig {
  favoritenlisteTextStandard?: string,
  favoritenlisteTextEdit?: string
}
const favoritenliste = document.getElementById('bmfwfLinkverwaltung');
let linklisteConfig: linklisteConfig = {
  favoritenlisteTextStandard: '',
  favoritenlisteTextEdit:''
};

if (favoritenliste) {
  linklisteConfig = favoritenliste.dataset;
}

interface linklisteFavoritenConfig {
  linklisteLink?: string
}

const linklisteFavoriten = document.getElementById('bmfwfLinkanzeige');
let linklisteFavoritenConfig: linklisteFavoritenConfig = {
  linklisteLink: '/'
};

if (linklisteFavoriten) {
  linklisteFavoritenConfig = linklisteFavoriten.dataset;
}


interface betriebsmitteilungenConfig {
  markNewItems?: string,
  newItemDays?: number
}

const betriebsmitteilungen = document.getElementById('betriebsmitteilungen');
let betriebsmitteilungenConfig: betriebsmitteilungenConfig = {
  markNewItems: 'false',
  newItemDays: 2
};

if (betriebsmitteilungen) {
  betriebsmitteilungenConfig = betriebsmitteilungen.dataset;
}

interface rssfindokConfig {
  findokUrl?: string,
  header?: string,
  mockResults?: string,
  findokExternalUrl?: string,
  findokExternalUrlText?: string
}

const rssfindok = document.getElementById('rssfindok');
let rssfindokConfig: rssfindokConfig = {
  findokUrl: '#',
  header: 'personalisierte Findok Neuzugänge',
  mockResults: 'false',
  findokExternalUrl: '',
  findokExternalUrlText: ''
};

if (rssfindok) {
  rssfindokConfig = rssfindok.dataset;
}

export default {
  baseUrl: globalConfig.vueWidgetBaseUrl || '/',
  baseApiUrl: globalConfig.vueWidgetBaseApiUrl || '/',
  anwendungslisteLink: anwendungslisteFavoritenConfig.anwendungslisteLink || '/',
  anwendungslisteTextStandard: anwendungslisteConfig.anwendungslisteTextStandard || '',
  anwendungslisteTextEdit: anwendungslisteConfig.anwendungslisteTextEdit || '',
  betriebsmitteilungenNewItemDays: betriebsmitteilungenConfig.newItemDays || 2,
  betriebsmitteilungenMarkNewItems: betriebsmitteilungenConfig.markNewItems || 'false',
  rssfindokUrl: rssfindokConfig.findokUrl || '',
  rssfindokHeader: rssfindokConfig.header || '',
  rssfindokMockResults: rssfindokConfig.mockResults || 'false',
  rssfindokExternalUrl: rssfindokConfig.findokExternalUrl || '',
  rssfindokExternalUrlText: rssfindokConfig.findokExternalUrlText || ''
}
